import constants from './const';

let baseUrl = '';

if (process.env.NODE_ENV === 'development') {
  baseUrl = constants.BASE_DEV_ROUTE;
} else if (process.env.REACT_APP_HOST_ENV === 'staging') {
  baseUrl = constants.BASE_STAGING_ROUTE
} else {
  baseUrl = constants.BASE_PROD_ROUTE
}

export default {
  baseUrl,
  endpoints: {

    version: '/api/v1',

    routes: {
      getAllCites: '/getAllCities',
      getCategories: '/getCategories',
      contactUs: '/createQuestion',

      register: '/registerUseEmail',
      login: '/loginUseEmail',
      logout: '/logoutUser',
      getUserInfo: '/getUserInfo',
      resetPassword: '/resetPassword',
      resetPasswordCheckToken: '/resetPasswordCheckToken',
      resetPasswordConfirm: '/resetPasswordConfirm',
      /**
       * Profile
       * */
      editUserInfo: '/editUserInfo',
      editUserEmail: '/editUserEmail',
      editUserPassword: '/editUserPassword',
      deleteUserAccount: '/deleteUserAccount',
      /**
       * Vendor Tour
       * */
      createTour: '/createTour',
      getMyTourList: '/getMyTours',
      getMyTourById: '/getMyTourById',
      deletePhotoTour: '/deletePhotoTour',
      addPhotoTour: '/addPhotoTour',
      addVideoTour: '/addVideoTour',
      deleteVideoTour: '/deleteVideoTour',
      editTour: '/editTour',
      deleteTour: '/deleteTour',
      /**
       * Tour
       * */
      getTours: '/getTours',
      getTourById: '/getTourById',
      /**
       * Cart
       * */
      getToursForCart: '/getToursForCart',
      /**
       * Booking
       * */
      createOrder: '/createOrder',
      /**
       * User Orders
       * */
      userGetMyOrders: '/userGetMyOrders',
      userGetOneOrder: '/userGetOneOrder',
    },

    genContactUsUrl() {
      return `${baseUrl}${this.version}${this.routes.contactUs}`
    },

    genResetPasswordConfirmUrl() {
      return `${baseUrl}${this.version}${this.routes.resetPasswordConfirm}`
    },

    genResetCheckHashUrl() {
      return `${baseUrl}${this.version}${this.routes.resetPasswordCheckToken}`
    },

    genResetPasswordSendEmailUrl() {
      return `${baseUrl}${this.version}${this.routes.resetPassword}`
    },

    genUserGetOneOrder() {
      return `${baseUrl}${this.version}${this.routes.userGetOneOrder}`
    },

    genUserGetMyOrdersUrl() {
      return `${baseUrl}${this.version}${this.routes.userGetMyOrders}`
    },

    genCreateOrder() {
      return `${baseUrl}${this.version}${this.routes.createOrder}`
    },

    gengetToursForCart(){
      return `${baseUrl}${this.version}${this.routes.getToursForCart}`
    },

    genGetTourByIdUrl(){
      return `${baseUrl}${this.version}${this.routes.getTourById}`
    },

    genGetToursUrl(){
      return `${baseUrl}${this.version}${this.routes.getTours}`
    },

    genGetCategoriesUrl(){
      return `${baseUrl}${this.version}${this.routes.getCategories}`
    },

    genDeleteUserAccountUrl(){
      return `${baseUrl}${this.version}${this.routes.deleteUserAccount}`
    },

    genEditUserPasswordUrl(){
      return `${baseUrl}${this.version}${this.routes.editUserPassword}`
    },

    genEditUserEmailUrl(){
      return `${baseUrl}${this.version}${this.routes.editUserEmail}`
    },

    genEditUserInfoUrl(){
      return `${baseUrl}${this.version}${this.routes.editUserInfo}`
    },

    genGetAllCitiesUrl(){
      return `${baseUrl}${this.version}${this.routes.getAllCites}`
    },

    genDeleteVideoTourUrl(){
      return `${baseUrl}${this.version}${this.routes.deleteVideoTour}`
    },

    genUploadTourVideoUrl(){
      return `${baseUrl}${this.version}${this.routes.addVideoTour}`
    },

    genDeleteTourUrl(){
      return `${baseUrl}${this.version}${this.routes.deleteTour}`
    },

    genEditTourUrl(){
      return `${baseUrl}${this.version}${this.routes.editTour}`
    },

    genAddPhotoTourUrl() {
      return `${baseUrl}${this.version}${this.routes.addPhotoTour}`
    },

    genDeletePhotoTourUrl() {
      return `${baseUrl}${this.version}${this.routes.deletePhotoTour}`
    },

    genGetMyTourByIdUrl() {
      return `${baseUrl}${this.version}${this.routes.getMyTourById}`
    },

    genGetMyTourListUrl() {
      return `${baseUrl}${this.version}${this.routes.getMyTourList}`
    },

    genCreateTourUrl() {
      return `${baseUrl}${this.version}${this.routes.createTour}`
    },

    genRegisterUrl() {
      return `${baseUrl}${this.version}${this.routes.register}`
    },
    genLoginUrl() {
      return `${baseUrl}${this.version}${this.routes.login}`
    },
    genLogoutUrl() {
      return `${baseUrl}${this.version}${this.routes.logout}`
    },
    genGetUserInfoUrl() {
      return `${baseUrl}${this.version}${this.routes.getUserInfo}`
    },
    genImageUrl(path, forUpdate) {
      return `${baseUrl}${path}?updated_at=${forUpdate}`
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/config/api.js